<template>
  <div
    class="c-mobile-sub-nav j-nav-item"
  >
    <nuxt-link
      v-if="isLink"
      role="button"
      :to="navLink"
      class="c-mobile-sub-nav__navigation"
      :class="{
        'c-mobile-sub-nav__navigation--has-image': navImage
      }"
    >
      <nuxt-img
        v-if="navImage"
        v-bind="$getImgOptions(navImage, { width: 1200, format: 'webp' })"
      />
      <span class="t-heading-6">{{ navTitle }}</span>
    </nuxt-link>
    <button
      v-else
      class="c-mobile-sub-nav__navigation"
      :class="{
        'c-mobile-sub-nav__navigation--has-image': navImage
      }"
      type="button"
      :aria-expanded="(navVisible) ? 'true' : 'false'"
      @click="showSubMenu"
      @mouseover="hoverShow"
    >
      <nuxt-img
        v-if="navImage"
        v-bind="$getImgOptions(navImage, { width: 1200, format: 'webp' })"
      />
      <span class="t-heading-6">{{ navTitle }}</span>
    </button>
    <div
      v-if="subNavVisible"
      ref="menu"
      class="c-mobile-sub-nav__menu u-background-color-base j-nav-item__menu"
    >
      <header
        ref="header"
        class="c-mobile-sub-nav__header j-nav-item__header t-heading-6"
      >
        {{ navTitle }}
      </header>
      <div
        ref="scroller"
        class="c-mobile-sub-nav__scroll u-background-color-base j-nav-item__scroll"
      >
        <nav-content
          :nav-item="navItem"
          :is-mobile="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import NavContent from '../NavContent'
import SubNavMixin from '../SubNavMixin'
import { UrlFilters } from '@mixins/cdnMixins'
export default {
  name: "MobileSubNav",
  components:{
    NavContent,
  },
  mixins: [
    SubNavMixin,
    UrlFilters
  ],
  props:{
    navItem: {
      type: Object,
      default: null
    },
    tabindexStart: {
      type: Number,
      default: 10
    },
    mobileNav: {
      type: Boolean,
      default: false,
    },
    searchVisible: {
      type: Boolean,
      default: false
    },
    navVisible: {
      type: Boolean,
      default: false
    },
    navItemVisible: {
      type: Object,
      default: () => ({})
    },
    bannerHeight: {
      type: Object,
      default: () => {}
    },
    menuHeight: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showingMenu: false,
      menuActive: false,
      menuBottom: null,
      menuTop: null,
      bounceTime: 0
    };
  },
  computed: {
    navImage() {
      const navItem = this.navItem
      const isLink = this.isLink
      const result = (isLink)
        ? get(navItem, 'data.backgroundImage')
        : get(navItem, 'data.image')
      return (result && result.src) ? result : null
    },
    navTitle() {
      return get(this.navItem, 'data.title')
    },
  },
  watch:{
    $route(){
      this.hideSubMenu();
    }
  },
  methods: {
    showSubMenu(){
      if (this.searchVisible == true){
        this.closeSearch()
      }
      /*
      this.startMouseTracking();
      if (this.showingMenu && noClose !== true && this.bounceCleared()){
        this.hideSubMenu();
        return;
      }
      if (this.menuActive){ //if still active, just leave alone
        return;
      }
      */
      this.showMenu(this.myIndex)
      /*
      this.menuActive = true;
      if (this.bounceCleared()){
        this.bounceTime = Date.now();
      }
      this.$nextTick(() => {
        this.showingMenu = true;
        this.findTop();
        this.sizeScroller();
      });
      */
    },
    hideSubMenu(){
      this.closeMenu(this.myIndex)
    },
    closeSearch() {
      this.$emit("hideSearch");
    },
    closeMenu(id) {
      this.$emit("hideDrawingMenu", id);
    },
    showMenu(id){
      this.$emit("showDrawingMenu", id);
    },
    sizeScroller(){
      let scroller = this.$refs.scroller;
      if (scroller) {
        try {
          const top = this.$refs.menu.getBoundingClientRect().top;
          const headerHeight = this.$refs.header.getBoundingClientRect().height;
          let height = document.documentElement.clientHeight;
          height -= top;
          height -= headerHeight;
          scroller.style.height = `${height}px`;
        } catch (err) {
          console.warn(err)
        }
      }
    },
    findTop(){
      try {
        let topEl = this.$refs.menu;
        topEl.style.top = null; //clear it for normal CSS
      } catch(err) {
        console.warn(err)
      }
    },
    calculateCardTabIndex(item){
      if(item.secondaryNavItems){
        return item.secondaryNavItems.length;
      }
      return 0;
    },
    hoverShow(){
      if(this.searchVisible){
        this.$emit("hideSearch");
        this.showSubMenu();
        this.startMouseTracking();
      }
    },
    startMouseTracking(){
      window.addEventListener("mousemove", this.trackMouse);
    },
    trackMouse(e){
      if(!this.showingMenu || !this.menuActive){
        return;
      }
      let menuEl = this.$refs.menu;
      if(menuEl){
        this.menuBottom = menuEl.getBoundingClientRect().bottom + 25;
        this.menuTop = menuEl.getBoundingClientRect().top;
      }
      let navItemEls = document.getElementsByClassName("c-desktop-nav__item");
      let navMenuLeft = null;
      let navMenuRight = null;
      if (navItemEls) {
        navMenuLeft = navItemEls[0].getBoundingClientRect().left;
        navMenuRight = navItemEls[navItemEls.length - 1].getBoundingClientRect().right + 25;
      }

      if(this.menuBottom !== null && this.menuTop !== null){
        if(this.menuBottom < e.clientY || e.clientY < 45){
          this.hideSubMenu();
        }
        if(this.menuTop > e.clientY && (e.clientX < navMenuLeft || e.clientX > navMenuRight)){
          this.hideSubMenu();
        }
      }
    },
    stopMouseTracking(){
      window.removeEventListener("mousemove", this.trackMouse);
    },
    bounceCleared(){
      return Date.now() > (this.bounceTime + 1000);
    }
  }
}
</script>
<style lang="scss" scoped>
.c-mobile-sub-nav{
  position: relative;
  margin-top: rem(12px);

  .c-mobile-sub-nav__navigation {
    &--has-image {
      @include themify($themes){
        color: themed("foreground", "white-text");
      }
    }
  }

  &__navigation{
    @include buttonReset;
    @include themify($themes){
      color: themed("foreground");
    }
    padding: rem(40px) rem(25px);
    position: relative;
    cursor: pointer;
    display: block;
    width: 100%;
    text-align: left;
    text-decoration: none;
    &--right{
      float: right;
    }
    & > img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      object-fit: cover;
    }
  }

  &__menu{
    position: fixed;
    top: rem(60px); //default works for mobile
    left: 0;
    width: 100%;
    transition: max-height 0.3s, opacity 0.2s;
    //padding: $filter-padding;
    z-index: ($zindex-global-header - 1);
    // height: 100vh; //set default for mobile
    opacity: 1;
    max-height: 100%;
  }

  &__close{
    @include buttonReset;
    cursor: pointer;
  }

  &__header{
    text-align: center;
    margin-top: rem(30px);
    &::after {
      @include themify($themes) {
        border-bottom: $border themed("background", "x-light");
      }
      content: "";
      display: block;
      margin: 0 auto;
      width: 50%;
      padding-top: rem(15px);
    }
  }

  &__scroll{
    overflow-y: auto;
    padding: rem(60px) rem(140px);
    padding-bottom: rem(20px);
    height: rem(420px);

    @media only screen and (max-width: 1600px) {
      padding: rem(40px) 0 rem(20px) 0;
    }
    @include respond("tab-land"){
      padding: rem(40px) 0 rem(70px) 0;
      height: calc(100vh - 13rem);
      height: calc(100svh - 13rem);
    }
  }

  &__secondary{
    padding: $filter-padding;
  }

  &__cards{
    float: right;
    width: 87%;
    grid-gap: 1rem;
    @media only screen and (max-width: 1500px) {
      width: 85%;
    }
    @include respond("tab-land"){
      float: none;
      width: inherit;
    }
  }

  &__card {
    height: 100%;
    display: flex;

    &--first::v-deep {
      padding: 4rem 1.9rem;

      .c-nav-card__wrapper {
        .c-nav-card__header {
          margin: 0.5rem 0 0 !important;
        }
      }
    }
  }

  &__arrow {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(100%);
  }
}
</style>
